module.exports = __webpack_public_path__ + "static/buildtorent-afdc407ecd190dbaea7a097e294a444a.png";